// extracted by mini-css-extract-plugin
export default {"navbarSearchContainer":"navbarSearchContainer_bmvg"};